import React, { useCallback } from 'react';

import {
  changeComposeMediaMapConsent,
  changeComposeMediaMetadata,
} from '@/mastodon/actions/compose';
import { useAppDispatch, useAppSelector } from '@/mastodon/store';

export default function MediaMetadataUploadToggle() {
  const dispatch = useAppDispatch();
  const metadataEnabled = useAppSelector((state) => !!state.compose.get('media_metadata'));
  const mapEnabled = useAppSelector((state) => !!state.compose.get('media_map_consent'));
  const uploading = useAppSelector((state) => !!state.compose.get('is_uploading'));

  const toggleMetadata = useCallback(() => {
    if (!uploading) dispatch(changeComposeMediaMetadata(!metadataEnabled));
  }, [dispatch, metadataEnabled, uploading]);

  const toggleMap = useCallback(() => {
    if (!uploading && metadataEnabled) dispatch(changeComposeMediaMapConsent(!mapEnabled));
  }, [dispatch, mapEnabled, metadataEnabled, uploading]);

  return (
    <span className='paxsudos-media-consents'>
      <button
        type='button'
        className={`text-icon-button paxsudos-exif-toggle${metadataEnabled ? ' active' : ''}`}
        aria-pressed={metadataEnabled}
        disabled={uploading}
        onClick={toggleMetadata}
        title={metadataEnabled
          ? 'Lupa annettu: lue tämän julkaisun uusien kuvalatausten EXIF-metadata'
          : 'Anna lupa lukea tämän julkaisun uusien kuvalatausten EXIF-metadata'}
      >
        EXIF
      </button>

      <button
        type='button'
        className={`text-icon-button paxsudos-map-consent-toggle${mapEnabled ? ' active' : ''}`}
        aria-pressed={mapEnabled}
        disabled={uploading || !metadataEnabled}
        onClick={toggleMap}
        title={!metadataEnabled
          ? 'Karttajulkaisu vaatii ensin EXIF-luvan'
          : mapEnabled
            ? 'Lupa annettu: GPS-sijainnin saa julkaista mediakartalla, jos postaus on julkinen'
            : 'Anna erillinen lupa GPS-sijainnin julkaisemiseen mediakartalla'}
      >
        Kartta
      </button>
    </span>
  );
}
